import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getAdminInfo } from '@/services/api/api';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const [authState, setAuthState] = useState('loading'); // loading | valid | invalid
  const adminName = localStorage.getItem('adminName');
  const role = localStorage.getItem('adminRole');

  useEffect(() => {
    // Se não tem dados no localStorage, nem precisa verificar
    if (!adminName) {
      setAuthState('invalid');
      return;
    }

    // Valida a sessão real no backend via cookie HttpOnly
    getAdminInfo()
      .then((res) => {
        if (res.data) {
          // Atualiza localStorage com dados frescos do backend
          localStorage.setItem('adminName', res.data.name);
          localStorage.setItem('adminRole', res.data.role);
          if (res.data.unit_id) localStorage.setItem('adminUnitId', res.data.unit_id);
          if (res.data.barber_id) localStorage.setItem('adminBarberId', res.data.barber_id);
          setAuthState('valid');
        } else {
          // Cookie inválido/expirado — limpa localStorage
          localStorage.removeItem('adminName');
          localStorage.removeItem('adminRole');
          localStorage.removeItem('adminUnitId');
          localStorage.removeItem('adminBarberId');
          localStorage.removeItem('adminToken');
          setAuthState('invalid');
        }
      })
      .catch(() => {
        localStorage.removeItem('adminName');
        localStorage.removeItem('adminRole');
        localStorage.removeItem('adminUnitId');
        localStorage.removeItem('adminBarberId');
        localStorage.removeItem('adminToken');
        setAuthState('invalid');
      });
  }, [adminName]);

  if (authState === 'loading') {
    return <div className="min-h-screen bg-[#09090b]" />;
  }

  if (authState === 'invalid') {
    return <Navigate to="/admin/login" replace />;
  }

  // Rotas que exigem papel de admin bloqueiam employees (role === 'employee')
  // SUPER_ADMIN tem acesso total
  if (requireAdmin && role !== 'admin' && role !== 'SUPER_ADMIN') {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default ProtectedRoute;
